/* tslint:disable */
/* eslint-disable */
export enum WorkProjectCheckRuleMessageEnum {
  Ok = 'OK',
  Warning = 'WARNING',
  Problem = 'PROBLEM',
  None = 'NONE'
}
